module.exports = [{
      plugin: require('../../../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"zaihui","short_name":"zaihui","start_url":"/","background_color":"#F8F8F8","theme_color":"#E95E3D","display":"minimal-ui","icon":"src/images/zaihui-icon.png"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
